import { useCallback, useState } from "react";
import {
  fetchCustomerProfileByPhone,
  createCustomer,
  updateCustomer,
  searchCustomers,
} from "../../models/shared/customersModel";

export function useCustomerProfile() {
  const [customer, setCustomer] = useState(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const loadByPhone = useCallback(async (phone) => {
    setLoading(true);
    setError(null);
    try {
      const result = await fetchCustomerProfileByPhone(phone);
      setCustomer(result);
      return result;
    } catch (e) {
      setError(e.message);
      return null;
    } finally {
      setLoading(false);
    }
  }, []);

  const create = useCallback(async (payload) => {
    const res = await createCustomer(payload);
    if (!res.success) throw new Error(res.message);
    return res;
  }, []);

  const update = useCallback(async (payload) => {
    const res = await updateCustomer(payload);
    if (!res.success) throw new Error(res.message);
    setCustomer(res.data);
    return res;
  }, []);

  const search = useCallback((term) => searchCustomers(term), []);

  return { customer, loading, error, loadByPhone, create, update, search, setCustomer };
}
